import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';

const tryToFetchUnreadCount = (): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(
        `${DEVICE_INFO_API_URL}/knowledge-base/notifications/unread-count`,
    );
};

const tryToFetchNotifications = (
    pageNumber: number,
    pageSize: number,
): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/knowledge-base/notifications?page=${pageNumber}&size=${pageSize}`;
    return deviceInfoAxios.get<any>(url);
};

const tryToMarkAsRead = (id: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.patch(
        `${DEVICE_INFO_API_URL}/knowledge-base/notifications/${id}/read`,
    );
};

export const KnowledgeBaseNotificationsService = {
    tryToFetchUnreadCount,
    tryToFetchNotifications,
    tryToMarkAsRead,
};
